import { SET_VEHICLES_VENDORS_LIST_IN_STORE } from "./types"

export const setVendorsListInStore = (data) => {
    return {
        type: SET_VEHICLES_VENDORS_LIST_IN_STORE,
        data
    }
}